import { useEffect, useMemo, useState, type ReactNode } from 'react'
import { getGameToolVersion } from '../api/gameToolVersion'
import {
  getCampDataRuntimeConfig,
  initializeCampDataVersion,
  setCampDataVersionContext,
  type CampDataVersionContext,
} from '../api/dataVersion'

type State =
  | { status: 'pending' }
  | { status: 'success'; context: CampDataVersionContext }
  | { status: 'error' }

export function DataVersionGate({ children }: { children: (context: CampDataVersionContext) => ReactNode }) {
  const config = useMemo(() => getCampDataRuntimeConfig(), [])
  const [attempt, setAttempt] = useState(0)
  const [state, setState] = useState<State>(() => config.source === 'local'
    ? { status: 'success', context: { version: config.version, dataRoot: config.dataRoot } }
    : { status: 'pending' })

  useEffect(() => {
    if (config.source === 'local') {
      setCampDataVersionContext({ version: config.version, dataRoot: config.dataRoot })
      return
    }
    let active = true
    setState({ status: 'pending' })
    initializeCampDataVersion(config, window.location, getGameToolVersion)
      .then((context) => {
        setCampDataVersionContext(context)
        if (active) setState({ status: 'success', context })
      })
      .catch((error) => {
        console.error('[camp:data-version] initialization failed', error)
        if (active) setState({ status: 'error' })
      })
    return () => { active = false }
  }, [attempt, config])

  if (state.status === 'pending') return <div className="flex items-center justify-center min-h-screen text-gray-400">加载中...</div>
  if (state.status === 'error') return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 text-gray-500">
      <div>数据初始化失败，请稍后重试</div>
      <button type="button" onClick={() => setAttempt((current) => current + 1)}>重新加载</button>
    </div>
  )
  setCampDataVersionContext(state.context)
  return <>{children(state.context)}</>
}
